<template>
  <div class="container">
    <a v-if="social.instagram" :href="social.instagram" target="_blank">
      <img :src="baseUrl + '/instagram-48-pink.png'" alt="instagram" />
    </a>
    <a v-if="social.twitter" :href="social.twitter" target="_blank">
      <img :src="baseUrl + '/twitter-48-pink.png'" alt="twitter" />
    </a>
    <a v-if="social.telegram" :href="social.telegram" target="_blank">
      <img :src="baseUrl + '/telegram-40-gray.png'" alt="telegram" />
    </a>
  </div>
</template>

<script setup lang="ts">
const $config = useRuntimeConfig().public;

const { $ThemeManager } = useNuxtApp();

const social = {
  instagram: $config.VUE_APP_SOCIAL_INSTAGRAM,
  twitter: $config.VUE_APP_SOCIAL_TWITTER,
  telegram: $config.VUE_APP_SOCIAL_TELEGRAM,
};

if ($ThemeManager.isChadsTheme()) {
  social.instagram = $config.VUE_APP_SOCIAL_INSTAGRAM_CHADS;
  social.twitter = $config.VUE_APP_SOCIAL_TWITTER_CHADS;
  social.telegram = $config.VUE_APP_SOCIAL_TELEGRAM_CHADS;
}

const baseUrl = computed(() => {
    let url = '/img';

    if ($ThemeManager.isChadsTheme()) {
      url += '/themes/chads';
    }

    return url + '/socials';
  }
);
</script>

<style scoped lang="scss">
.container {
  display: flex;

  a {
    display: flex;
    align-items: center;
    font-size: 0.8em;
    //margin-bottom: 5px;
    font-weight: bold;

    &:hover {
      color: #ccc;
    }

    @media (max-width: 900px) {
      justify-content: center;
    }

    img {
      width: 38px;

      @media (max-width: 768px) {
        width: 30px;
      }
    }

    &:not(:last-of-type) img {
      margin-right: 0.5em;
    }
  }
}
</style>
